import { ListItemIcon, ListItemText, MenuItem, Switch } from '@mui/material';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import { useUserMenu } from 'react-admin';
import { openWhatsNew, setGuideEnabled, useGuideState } from './guideStore';

/**
 * Pozycje przewodnika po zmianach w menu użytkownika (21.10.2026):
 * „Przewodnik po zmianach” — włącz/wyłącz (pamiętane dla konta w tej
 * przeglądarce) i „Co nowego” — lista przewodników. Za przełącznikiem
 * `guideOverlay` (S-21.10-28) — bramkę stawia menu użytkownika.
 */
export const GuideMenuItems = () => {
  const s = useGuideState();
  const userMenu = useUserMenu();
  return (
    <>
      <MenuItem
        onClick={() => setGuideEnabled(!s.enabled)}
        role="menuitemcheckbox"
        aria-checked={s.enabled}
        data-testid="guide-menu-toggle"
      >
        <ListItemIcon>
          <SchoolOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Przewodnik po zmianach" secondary={s.enabled ? 'włączony' : 'wyłączony'} />
        <Switch size="small" edge="end" checked={s.enabled} tabIndex={-1} slotProps={{ input: { 'aria-hidden': true } }} />
      </MenuItem>
      <MenuItem
        onClick={() => {
          userMenu?.onClose();
          openWhatsNew();
        }}
        data-testid="guide-whats-new"
      >
        <ListItemIcon>
          <NewReleasesOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Co nowego</ListItemText>
      </MenuItem>
    </>
  );
};
